/** Префікс ID власного модуля як у прототипі v4 (onBPrefix): великі латинські літери й цифри, не більше 6 символів. Чиста функція. */
export function normalizePrefix(value: string): string {
  return value.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 6);
}
